import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetMaterialCommonList } from 'features/material-details/use-cases/get-commonmasterlist';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingFilterFormField, LoadingFilterFormValues, MaterialDetailFilterFormValues } from './type';

const { useBreakpoint } = Grid;

type VehicleFilterFormProps = {
  formId: string;
  handleFilter: (values: MaterialDetailFilterFormValues) => void;
  initialValues: MaterialDetailFilterFormValues;
  closeModal?: () => void;
  onRefresh: () => void;
};

export const MatrialDetailsViewFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  onRefresh
}: VehicleFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<LoadingFilterFormValues>();
  const { t } = useTranslation();
  const { data: materialDetailType } = useGetMaterialCommonList({
    Flag: "MaterialDetailType",
  } as any);
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();
  const onReset = () => {
    

    form.resetFields();
    handleFilter(initialValues);
    onRefresh();

  };

  const onFinish = (formValues: LoadingFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };
  if (roleTypeFilterLoading) return null;

  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }


  return (
    <Form<LoadingFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className='cf_frm' style={{ width: '100%' }}>
        <StandardItemsWrapper className='cf_frm_row' style={{ width: '100%' }}>
          <div className='invoice_list' style={{ width: '100%' }}>
            <Form.Item<LoadingFilterFormValues>
              label={'Material Name	'}
              name={LoadingFilterFormField.MaterialName}
            >
              <Input
                placeholder={'Enter Material Name'}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label={'Material Type'}
              name={LoadingFilterFormField.MaterialType}
            >
              <Select
                placeholder="Select Type"
                options={materialDetailType?.res?.commonList.map((item: any) => ({
                  label: item.title, // "Sales" / "Purchase"
                  value: item.id, // ✅ use title instead of id
                }))}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label={'Material Detail'}
              name={LoadingFilterFormField.Description}
            >
              <Input placeholder='Enter a material detail' />
            </Form.Item>

            {screens.lg && (
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit' >
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>


    </Form>
  );
};
